import { gql } from '@apollo/client';

export const UPDATE_LEASING_INTEREST = gql`
  mutation updateLeasingInterest($input: UpdateLeasingInterestInput) {
    updateLeasingInterest(input: $input) {
      commandId
    }
  }
`;
